import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Apiservice } from '../../../../services/ApiService';
import { VenueService } from '../../../../services/VenueService';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-add-feeds',
  templateUrl: './add-feeds.component.html',
  styleUrls: ['./add-feeds.component.scss', '../../styles/shared.scss']
})
export class AddFeedsComponent implements OnInit {
  Selectedvenue: string = '';
  addFeedType: string = '';
  deliveryOptions: any = [];
  deliveryName: string = '';
  bucket: string = '';
  columns: string = '';
  loading: boolean = false;
  active: string = 'YES';
  status: string = 'PENDING';
  username: string = '';
  password: string = '';
  url: string = '';
  eventBUS: string = '';
  stream: string = '';
  path: string = '';
  server: string = '';
  deliveryList: any = [];
  postdata: any = [];
  type: string = '';
  sendDates: { [date: string]: [number, number] | {} } = {};
  dates: string = '';
  dsnInput: string = '';
  dsnList: string[] = [];
  venueTimezone: string = '';
  editingTimeFor: string | null = null;
  editStart: string = '';
  editEnd: string = '';

  constructor(private _http: HttpClient,private router: Router, private apiservice: Apiservice, public venue: VenueService) {
  }

  feedDisplay(){
    this.router.navigate(['feeds']);
  }

  addFeedTypeChangeHandler(event: any) {
    this.addFeedType = event.target.value.toUpperCase();
}

getdeliveryOptions() {
  this.loading = true;
  this.apiservice.getDeliveryOptions().subscribe({
    next: (result: any) => {
      this.deliveryOptions = result;
      this.columns = this.deliveryOptions.availableFields;
    },
    error: (err) => {
      console.error("Error fetching delivery options", err);
    },
    complete: () => {
      setTimeout(() => {
        this.loading = false;
       }, 3000);
    },
  });
}

addFeed(feedType: string) {
  this.loading = true;

  if (!this.deliveryList) {
    this.deliveryList = { deliveryPoints: [] };
  }

  if (!this.deliveryList.deliveryPoints) {
    this.deliveryList.deliveryPoints = [];
  }

  const baseDeliveryPoint: any = {
    active: this.active,
    status: this.status,
    columns: this.columns,
    deliveryName: this.deliveryName,
    type: this.addFeedType,
  };

  switch (feedType) {
    case 'S3':
      Object.assign(baseDeliveryPoint, { bucket: this.bucket });
      break;
    case 'Kinesis':
      Object.assign(baseDeliveryPoint, { eventBusName: this.eventBUS, streamName: this.stream });
      break;
    case 'Azure':
      Object.assign(baseDeliveryPoint, { shared_access_url: this.url });
      break;
    case 'SFTP':
      Object.assign(baseDeliveryPoint, { path: this.path, username: this.username, password: this.password, server: this.server });
      break;
  }

  const existingIndex = this.deliveryList.deliveryPoints.findIndex((dp: { deliveryName: any; type: any }) =>
    dp.deliveryName === baseDeliveryPoint.deliveryName &&
    dp.type === baseDeliveryPoint.type
  );

  if (existingIndex === -1) {
    baseDeliveryPoint.datefilters = { ...this.sendDates };
    if (!baseDeliveryPoint.dsnfilters) {
      baseDeliveryPoint.dsnfilters = [];
    }
    baseDeliveryPoint.dsnfilters.push(...this.dsnList);

    this.deliveryList.deliveryPoints.push(baseDeliveryPoint);
  } else {
    console.log('Delivery point already exists!');
  }

  const body = {
    key: this.Selectedvenue + '_deliveryOptions',
    deliveryPoints: this.deliveryList.deliveryPoints,
  };

  this._http.post('https://57hb9ue4x9.execute-api.ap-southeast-2.amazonaws.com/prod/delivery', body)
    .subscribe({
      next: (data) => {
        this.postdata = data;
        this.loading = false;
      },
      error: (error) => {
        console.error(error);
        console.log(body);
      },
      complete: () => {
        this.router.navigate(['feeds']);
        this.loading = false;
      },
    });
}




getDeliveryNameValue(event: any){
  this.deliveryName = event.target.value;
}

getBucketValue(event: any){
  this.bucket = event.target.value;
}

getEventBUSValue(event: any){
  this.eventBUS = event.target.value;
}
getStreamValue(event: any){
  this.stream = event.target.value;
}

getTypeValue(event: any){
  this.type = event.target.value;
}

getPathValue(event: any){
  this.path = event.target.value;
}

getServerValue(event: any){
  this.server = event.target.value;
}

getUsernameValue(event: any){
  this.username = event.target.value;
}

getPasswordValue(event: any){
  this.password = event.target.value;
}

getURLValue(event: any){
  this.url = event.target.value;
}

getDates(event:any){
  this.dates = event.target.value;
  console.log(this.dates);
}

getDsnValue(event: any){
  this.dsnInput = event.target.value;
  console.log(this.dsnInput);
}

addDsn(event: any): void {
  console.log('Adding DSN:', this.dsnInput);
  const newDsn = this.dsnInput.trim();
  if (newDsn && !this.dsnList.includes(newDsn)) {
    this.dsnList.push(newDsn);
  }

  this.dsnInput = '';
  console.log('DSN List:', this.dsnList);
}
removeDsn(index: number): void {
  this.dsnList.splice(index, 1);
}

addDate(event: any): void {
  event.preventDefault();

  const rawValues = this.dates.split('\n').map((v: string) => v.trim()).filter((v: string) => v);
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

  const invalidDates: string[] = [];
  rawValues.forEach((dateStr: string) => {
    if (!dateRegex.test(dateStr)) {
      invalidDates.push(dateStr);
      return;
    }
    if (!this.sendDates[dateStr]) {
      this.sendDates[dateStr] = {};
    }
  });

  if (invalidDates.length) {
    alert(`These dates are invalid: ${invalidDates.join(', ')}`);
  }

  this.dates = '';
}


removeChip(dateKey: string): void {
  delete this.sendDates[dateKey];
}

isTimeRange(value: any): boolean {
  return Array.isArray(value) && value.length === 2;
}

formatTimeRange(value: any): string {
  if (!this.isTimeRange(value)) return '';
  return `${this.epochToVenueTime(value[0]).time} – ${this.epochToVenueTime(value[1]).time}`;
}

isEditingTimes(dateKey: string): boolean {
  return this.editingTimeFor === dateKey;
}

startEditTimes(dateKey: string, value: any): void {
  this.editingTimeFor = dateKey;
  if (this.isTimeRange(value)) {
    this.editStart = this.epochToVenueTime(value[0]).time;
    this.editEnd = this.epochToVenueTime(value[1]).time;
  } else {
    this.editStart = '';
    this.editEnd = '';
  }
}

saveEditTimes(dateKey: string): void {
  const timeRegex = /^\d{2}:\d{2}$/;
  const hasStart = !!this.editStart;
  const hasEnd = !!this.editEnd;
  if (hasStart !== hasEnd) {
    alert('Both start and end time must be provided, or leave both empty for a full day.');
    return;
  }
  if (hasStart && (!timeRegex.test(this.editStart) || !timeRegex.test(this.editEnd))) {
    alert('Times must be in HH:MM format.');
    return;
  }
  if (hasStart) {
    const startEpoch = this.venueLocalToEpoch(dateKey, this.editStart);
    const endEpoch = this.venueLocalToEpoch(dateKey, this.editEnd);
    if (endEpoch <= startEpoch) {
      alert('End time must be after start time.');
      return;
    }
    this.sendDates[dateKey] = [startEpoch, endEpoch];
  } else {
    this.sendDates[dateKey] = {};
  }
  this.cancelEditTimes();
}

clearChipTimes(dateKey: string): void {
  this.sendDates[dateKey] = {};
  this.cancelEditTimes();
}

cancelEditTimes(): void {
  this.editingTimeFor = null;
  this.editStart = '';
  this.editEnd = '';
}

private epochToVenueTime(epochSeconds: number): { date: string; time: string } {
  const tz = this.venueTimezone || 'UTC';
  const parts = new Intl.DateTimeFormat('en-AU', {
    timeZone: tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).formatToParts(new Date(epochSeconds * 1000));
  const lookup: any = {};
  parts.forEach((p) => (lookup[p.type] = p.value));
  const hour = lookup.hour === '24' ? '00' : lookup.hour;
  return {
    date: `${lookup.year}-${lookup.month}-${lookup.day}`,
    time: `${hour}:${lookup.minute}`,
  };
}

private venueLocalToEpoch(dateStr: string, timeStr: string): number {
  const [y, m, d] = dateStr.split('-').map(Number);
  const [h, min] = timeStr.split(':').map(Number);
  const asIfUTC = Date.UTC(y, m - 1, d, h, min);
  const parts = new Intl.DateTimeFormat('en-AU', {
    timeZone: this.venueTimezone || 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(new Date(asIfUTC));
  const lookup: any = {};
  parts.forEach((p) => (lookup[p.type] = p.value));
  const hour = lookup.hour === '24' ? 0 : Number(lookup.hour);
  const asShown = Date.UTC(
    Number(lookup.year),
    Number(lookup.month) - 1,
    Number(lookup.day),
    hour,
    Number(lookup.minute),
    Number(lookup.second)
  );
  const offset = asShown - asIfUTC;
  return Math.floor((asIfUTC - offset) / 1000);
}







ngOnInit(): void {
  this.loading = true;
  this.Selectedvenue = history.state.Selectedvenue;
  this.deliveryList = history.state.deliveryList;
  this.deliveryOptions = history.state.deliveryOptions;
  this.venueTimezone = history.state.venueTimezone || '';
  this.getdeliveryOptions();

}

}
